import { render, staticRenderFns } from "./MaterialCategoryModal.vue?vue&type=template&id=3d75d572&scoped=true"
import script from "./MaterialCategoryModal.vue?vue&type=script&lang=js"
export * from "./MaterialCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d75d572",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d75d572')) {
      api.createRecord('3d75d572', component.options)
    } else {
      api.reload('3d75d572', component.options)
    }
    module.hot.accept("./MaterialCategoryModal.vue?vue&type=template&id=3d75d572&scoped=true", function () {
      api.rerender('3d75d572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/material/modules/MaterialCategoryModal.vue"
export default component.exports